export default __webpack_public_path__ + "static/vutlan-6f92645adf4045e78845796a217da845.jpg";